import { FileField } from '@sitecore-jss/sitecore-jss-nextjs';

type VideoSourceData =
  | {
      src: string;
      mimeType: string;
    }
  | undefined;

export const useVideoSource = (sources: FileField[]): VideoSourceData => {
  for (const source of sources) {
    let mimeType = (source?.value?.mimeType as string) || 'video/mp4';
    if (source?.value?.extension === 'webm') {
      mimeType = 'video/webm';
    }
    if (source?.value?.src) {
      return {
        src: source.value.src,
        mimeType: mimeType,
      };
    }
  }
  return undefined;
};
